export const INITIAL_PNR_VALUE = 9876543210;